import axios, { AxiosRequestConfig } from 'axios';
import { config } from '../constants/config';

const instance = axios.create({
  baseURL: config.apiUrl,
});

interface IProps {
  endpoint: string;
  options?: AxiosRequestConfig;
  token?: string;
  body?: any;
}

const get = ({ endpoint, token, options }: IProps) => {
  return instance.get(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    ...options,
  });
};

const post = ({ endpoint, token, body, options }: IProps) => {
  return instance.post(endpoint, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    ...options,
  });
};

const patch = ({ endpoint, token, body, options }: IProps) => {
  return instance.patch(endpoint, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    ...options,
  });
};
const remove = ({ endpoint, token, options }: IProps) => {
  return instance.delete(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      data: { some: 'some data' },
    },
  });
};

const getForSwr = (endpoint: string, token?: string) => {
  return instance.get(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
};

const api = {
  get,
  post,
  patch,
  getForSwr,
  remove,
};

export default api;
